import React from 'react';
import { numUSDT, usd } from '../../utils/format';

// Pure-SVG animated bar chart. No chart library, no callbacks.
export default function IncomeChart({ income }) {
  const bars = [
    { label: 'Sponsor', value: numUSDT(income?.sponsorIncome), color: '#f9d423' },
    { label: 'Level', value: numUSDT(income?.levelIncome), color: '#e6a817' },
    { label: 'Silver', value: numUSDT(income?.silverPoolIncome), color: '#c9d2e3' },
    { label: 'Gold', value: numUSDT(income?.goldPoolIncome), color: '#f5c518' },
    { label: 'Diamond', value: numUSDT(income?.diamondPoolIncome), color: '#2d9cdb' },
    { label: 'Special', value: numUSDT(income?.specialPoolIncome), color: '#c08bff' },
  ];

  const max = Math.max(...bars.map((b) => b.value), 1);
  const total = bars.reduce((s, b) => s + b.value, 0);

  if (total <= 0) {
    return <div className="empty">No income to chart yet — start earning!</div>;
  }

  const W = 320;
  const H = 150;
  const pad = 22;
  const slot = (W - pad * 2) / bars.length;
  const bw = slot * 0.5;

  return (
    <div>
      <svg viewBox={`0 0 ${W} ${H + 26}`} width="100%" style={{ display: 'block' }}>
        <defs>
          {bars.map((b, i) => (
            <linearGradient key={i} id={`bar${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={b.color} stopOpacity="0.95" />
              <stop offset="100%" stopColor={b.color} stopOpacity="0.35" />
            </linearGradient>
          ))}
        </defs>

        {/* baseline */}
        <line x1={pad} y1={H} x2={W - pad} y2={H} stroke="rgba(255,255,255,0.12)" strokeWidth="1" />

        {bars.map((b, i) => {
          const h = (b.value / max) * (H - 24);
          const x = pad + i * slot + (slot - bw) / 2;
          const y = H - h;
          return (
            <g key={i}>
              <rect
                x={x}
                y={y}
                width={bw}
                height={h}
                rx="5"
                fill={`url(#bar${i})`}
                style={{
                  transformOrigin: `${x + bw / 2}px ${H}px`,
                  animation: `barGrow .7s cubic-bezier(.2,.8,.2,1) ${i * 0.08}s both`,
                }}
              />
              <text x={x + bw / 2} y={H + 16} textAnchor="middle" fontSize="9" fill="#aeb6c8">
                {b.label}
              </text>
            </g>
          );
        })}
      </svg>
      <div className="card-row" style={{ marginTop: 8 }}>
        <span className="dim" style={{ fontSize: 12 }}>Total earned</span>
        <span className="gold-text" style={{ fontWeight: 800 }}>{usd(total)}</span>
      </div>
    </div>
  );
}
